import "./OnlineSession.styles.scss";
import React, { useState } from "react";
import { Button, Logo, PatientsDropdown } from "components";
import VideoCallGraphic from "assets/images/video-call-graphic.png";
import { useGetPatients } from "utils/hooks";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OnlineSession = () => {
  const [videoCall, setVideoCall] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const { uuid } = useParams();
  const { patients } = useGetPatients({});
  const patient = patients.find(
    (patient: any) => patient?.slug === uuid && uuid
  );
  const [currentPatient, setCurrentPatient] = useState(patient || null);
  const [currentPatientSelection, setCurrentPatientSelection] = useState({
    value: patient?.uuid,
    label: `${patient?.firstName} ${patient?.lastName}`,
  });

  const startVideoSession = async () => {
    setVideoCall(true);
  };

  const navigate = useNavigate();
  const handlePatientChange = (patientId: string) => {
    const newPatient = patients.find(
      (patient: any) => patient.uuid === patientId
    );
    setCurrentPatient(newPatient);
    navigate(`/session/${newPatient?.slug}`);
  };

  const handlePatientClear = () => {
    setCurrentPatient(null);
    navigate("/session");
  };

  const { t } = useTranslation();

  return (
    <div className="online-session">
      <div className="online-session_top-bar">
        <div className="online-session-top-bar_logo">
          <Logo theme={"white"} />
        </div>
      </div>
      <div className="online-session_body">
        {videoCall ? (
          <div style={{ width: "800px", height: "800px" }}>
            <p>call started</p>
          </div>
        ) : (
          <div className="online-session_pre-call-body">
            {currentPatient && (
              <h2
                dangerouslySetInnerHTML={{
                  __html: t(
                    "common_labels.online_session.ready_to_start_session",
                    {
                      firstName: currentPatient.firstName,
                    }
                  ),
                }}
              />
            )}
            <img src={VideoCallGraphic} alt="video call" />
            {!currentPatient && (
              <>
                <h3>
                  {t("common_labels.online_session.select_patient_to_start")}
                </h3>
                <p className="text">
                  {t("common_labels.online_session.browser_permissions_note")}
                  <br />{" "}
                  {t("common_labels.online_session.patient_notification_note")}
                </p>
                <PatientsDropdown
                  name="selectedPatient"
                  includeEmail={false}
                  placeholder={t("common_labels.choose_patient")}
                  onChange={(v) => {
                    handlePatientChange(v?.value);
                    setCurrentPatientSelection(v);
                  }}
                  hideSelectedOptions={false}
                  value={patient ? currentPatientSelection : null}
                />
              </>
            )}
            <div className="flex align-center justify-center">
              <Button
                onClick={() => startVideoSession()}
                name={`start_session_button`}
                value={
                  currentPatient
                    ? t(
                        "common_labels.online_session.start_session_with_patient",
                        {
                          firstName: currentPatient.firstName,
                        }
                      )
                    : t("common_labels.online_session.start_session_button")
                }
                extraClass="accent"
                disabled={!currentPatient}
              />
            </div>
            {currentPatient && (
              <div className="mt-2">
                <div
                  className="pseudo-link"
                  role="button"
                  tabIndex={0}
                  onClick={handlePatientClear}
                  onKeyDown={handlePatientClear}
                >
                  {t("common_labels.online_session.choose_different_patient")}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OnlineSession;
